import Icon from '../components/Icon';

const Weather13 = Icon(
  'weather-13',
  <>
    <path
      fillRule="evenodd"
      d="M11.192 1.25c-3.576 0-6.542 2.603-7.125 6.02a4.38 4.38 0 0 0-2.817 4.097 4.377 4.377 0 0 0 4.371 4.383h11.545c3.086 0 5.584-2.51 5.584-5.6 0-3.06-2.45-5.55-5.495-5.598a7.22 7.22 0 0 0-6.063-3.302m-5.7 6.665c.292-2.902 2.734-5.165 5.7-5.165 2.141 0 4.01 1.18 4.993 2.93a.75.75 0 0 0 .704.38q.138-.009.277-.009a4.09 4.09 0 0 1 4.084 4.1c0 2.266-1.83 4.099-4.084 4.099H5.621a2.877 2.877 0 0 1-2.871-2.883c0-1.353.928-2.487 2.177-2.799a.75.75 0 0 0 .565-.653"
      clipRule="evenodd"
    />
    <path d="M7 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 22a1 1 0 1 1-2 0 1 1 0 0 1 2 0M15 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  </>
);

export default Weather13;
